var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndus9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 49,
    viewBox: "0 0 39 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.5H38.5V47C38.5 47.8284 37.8284 48.5 37 48.5H2C1.17157 48.5 0.5 47.8284 0.5 47V14C0.5 10.4102 3.41015 7.5 7 7.5Z",
    stroke: "#000064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5H18C18.8284 12.5 19.5 13.1716 19.5 14V26C19.5 26.8284 18.8284 27.5 18 27.5H7C6.17157 27.5 5.5 26.8284 5.5 26V19C5.5 15.4101 8.41015 12.5 12 12.5Z",
    stroke: "#000064"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 39.5H24",
    stroke: "#000064"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 0.5,
    width: 11,
    height: 7,
    stroke: "#000064"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39C36 33 30 30 30 30C30 30 24 33 24 39C24 42.3125 26.7 45 30 45C33.3 45 36 42.3125 36 39Z",
    stroke: "#000064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndus9);
export default __webpack_public_path__ + "static/media/indus9.988fcb070820ed7f423b2f595aef449d.svg";
export { ForwardRef as ReactComponent };